import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { LoginConfirm as RedesignLoginConfirm } from '../../../pages';
import * as Actions from '../../actions/Actions';
import * as Api from '../../Api';
import * as Data from '../../Data';
import * as cookieConsentActions from '../../redux/cookie-consent/actions';
import { cookieSelectors } from '../../selectors';
import { flagService } from '../../services';
import * as Store from '../../Store';
import { default as LegacySmsCode } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignLoginConfirm,
  LegacySmsCode,
);

export type StateProps = {
  AfterLogin: string;
  allowGuestLogin: boolean;
  AppConfig: Data.Async<Api.AppConfig>;
  AppDesignScheme: Api.AppDesignScheme;
  DeviceId: string;
  enableRememberMe: boolean;
  hasGdprCookieFeatureFlag: boolean;
  isDark: boolean;
  isFunctionalCookieConsentEnabled: boolean;
  rememberMe: boolean;
  translate: any;
};

export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: Store.State): StateProps => {
  const restaurants = state.collectionRestaurants;
  const physicalRestaurantId = state.flipdish.LastRestaurantUrl.split(
    '/',
  ).pop();
  const currentRestuarant = restaurants[physicalRestaurantId];

  let allowGuestLogin = false;
  if (
    currentRestuarant?.status === 'success' &&
    parseInt(physicalRestaurantId)
  ) {
    allowGuestLogin = currentRestuarant.data.AllowGuestCheckout;
  }

  return {
    AfterLogin: state.flipdish.AfterLogin,
    allowGuestLogin,
    AppConfig: state.flipdish.AppConfig,
    AppDesignScheme: state.appDesignScheme,
    DeviceId: state.flipdish.Config.DeviceId,
    enableRememberMe: cookieSelectors.enableRememberMe(state),
    hasGdprCookieFeatureFlag: cookieSelectors.hasGdprCookieFeatureFlag(state),
    isDark: state.flipdish.isDark,
    isFunctionalCookieConsentEnabled: cookieSelectors.isFunctionalCookieConsentEnabled(
      state,
    ),
    rememberMe: state.cookieConsent.rememberMe,
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  Login: () => {
    dispatch(Actions.LoadCustomer());
  },
  setRememberMe: (value: boolean) =>
    dispatch(cookieConsentActions.setRememberMe(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(pageComponent);
